module.exports = __webpack_public_path__ + "static/media/pw-win-percent-icon.93dba7ba.svg";